<template>
  <div class="py-10 bg-residence">
    <div style="margin:0 10%; ">
      <h1>
        บริการวิชาการ
        <v-btn class="ml-5 mt-0" color="#636262" text fab @click="openSetting()" v-if="mode">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </h1>
      <v-card color="primary" class="mt-3" tile style="height:8px; width:150px;"></v-card>
      <v-menu close-on-content-click bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="float-right" color="primary" dark v-bind="attrs" v-on="on">
            {{all_data[select_items].curriculum_name}}
            <v-icon class="ml-1">mdi-menu-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in all_data" :key="index" @click="select_items=index">
            <v-list-item-title>{{ item.curriculum_name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="pt-10 mt-4">
        <v-card class="pa-8 py-10" style="opacity:0.9;">
          <h2
            class="primary--text font-weight-bold pl-4 pb-3"
          >{{all_data[select_items].curriculum_name}}</h2>
          <!-- <pre>{{all_data}}</pre> -->
          <v-row class="py-0 px-8">
            <span
              v-if="all_data[select_items].file==''"
              class="font-weight-bold pl-4 py-2"
            >- ไม่มีข้อมูล</span>
            <v-col cols="6" v-for="(file, i) in all_data[select_items].file" :key="i" class="py-2">
              <li v-if="file">
                <span class="font-weight-bold">{{file.curriculum_attachment_name +' '}}</span>
                <!-- <span>( {{table.file_date}} )</span> -->
                <span class="ml-1">
                  <v-btn
                    @click="getDownloadSpecializedCourses(file.curriculum_attachment_id,file.curriculum_attachment_name,file.curriculum_attachment_path)"
                    color="primary"
                    dark
                    text
                    class="font-weight-bold mb-1"
                    style="text-decoration:underline"
                  >ไฟล์</v-btn>
                </span>
              </li>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <DialogAcademicServices ref="dialog_academicservice_setting" @getacademicservice="getData()"></DialogAcademicServices>
  </div>
</template>
<script>
import DialogAcademicServices from "../Settings/DialogAcademicServices";
export default {
  components: {
    DialogAcademicServices
  },
  data: () => ({
    select_items: 0,
    all_data: [],
    mode: false
  }),
  created() {
    this.mode = this.$session.get("token") ? true : false;
    this.getData();
  },
  methods: {
    openSetting() {
      this.$refs.dialog_academicservice_setting.openSetting();
    },
    getData() {
      let data = [];
      for (let index = 7; index < 11; index++) {
        this.axios
          .get(process.env.VUE_APP_API + "/api/v1/curriculum/" + index)
          .then(response => {
            // console.log(response.data[0]);
            // this.all_data = response.data;
            data.push(response.data[0]);
          });
        this.all_data = data;
      }
    },
    getDownloadSpecializedCourses(id, file_name, file_path) {
      const url = process.env.VUE_APP_API + file_path;
      window.open(url);
      // this.axios({
      //   url:
      //     process.env.VUE_APP_API + "/api/v1/operating_schedule/download/" + id,
      //   method: "GET",
      //   responseType: "blob", // important
      //   headers: { Authorization: "Bearer " + this.$session.get("token") }
      // }).then(response => {
      // console.log(response);
      // const url = window.URL.createObjectURL(new Blob([response.data]));
      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", file_name); //or any other extension
      // document.body.appendChild(link);
      // link.click();
      // });
    }
  }
};
</script>